import React from 'react';
import { IconClose } from '../../Icons';
import { StatusLabel } from '../../ui/StatusLabel';

export interface DroneTypeInfo {
	id: number;
	name: string;
	reachDiameter: number;
	flightSpeed: number;
	startStopTime: number;
	maxFlightTime: number;
	fhModelKey?: string;
	fhDomain?: string;
	fhType?: string;
	fhSubType?: string;
	fhDeviceClass?: string;
}

export interface DroneInfo {
	id: number;
	name: string;
	serialNumber?: string;
	callsign?: string;
	deviceOnlineStatus?: boolean;
	modeCode?: number;
	droneType: DroneTypeInfo;
}

interface DroneCardProps {
	drone: DroneInfo;
	selected?: boolean;
	onClick?: (drone: DroneInfo) => void;
	onDelete?: (drone: DroneInfo) => void;
}

export const DroneCard: React.FC<DroneCardProps> = ({
	drone,
	selected = false,
	onClick,
	onDelete,
}) => {
	const onlineStatus: 'ONLINE' | 'OFFLINE' = drone.deviceOnlineStatus
		? 'ONLINE'
		: 'OFFLINE';
	const selectDrone = () => onClick?.(drone);
	const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			selectDrone();
		}
	};

	return (
		<div
			data-pw="drone-card"
			role="button"
			tabIndex={0}
			aria-pressed={selected}
			aria-label={`${drone.name} auswählen`}
			className={`rounded-[20px] border px-6 py-8 flex flex-col cursor-pointer transition-colors ${selected
				? 'border-blue-400 bg-blue-50'
				: 'border-[#EDF4FA] bg-[#EDF4FA] hover:border-gray-300'
				}`}
			onClick={selectDrone}
			onKeyDown={onKeyDown}
		>
			<div className="flex items-center justify-between gap-2 mb-3">
				<span className="text-2xl">{drone.name}</span>
				<div className="flex items-center gap-2">
					{drone.deviceOnlineStatus !== undefined && (
						<StatusLabel>{onlineStatus}</StatusLabel>
					)}
					{onDelete && (
						<button
							type="button"
							className="text-gray-400 hover:text-red-500 transition-colors"
							onClick={(e) => {
								e.stopPropagation();
								onDelete(drone);
							}}
						>
							<IconClose />
						</button>
					)}
				</div>
			</div>

			{drone.callsign && (
				<div className="flex gap-2">
					<span className="w-20 shrink-0 text-base">Call Sign</span>
					<span className="text-base font-semibold">{drone.callsign}</span>
				</div>
			)}
			{drone.droneType.name && (
				<div className="flex gap-2">
					<span className="w-20 shrink-0 text-base">
						Modell
					</span>
					<span className="text-base font-semibold">
						{drone.droneType.name}
					</span>
				</div>
			)}

			{drone.serialNumber && (
				<div className="flex gap-2">
					<span className="w-20 shrink-0 text-base ">Seriennr.</span>
					<span className="text-base font-semibold">
						{drone.serialNumber}
					</span>
				</div>
			)}


		</div>
	);
};
